module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.coordinate) ? _c('div', {
    attrs: {
      "id": "componentCoordinates"
    }
  }, [_c('div', {
    class: {
      active: _vm.expanded
    },
    on: {
      "click": function($event) {
        _vm.expanded = !_vm.expanded
      }
    }
  }, [_c('span', [_vm._v("Lat: " + _vm._s(_vm.coordinate.lat.toFixed(4)))]), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("Lng: " + _vm._s(_vm.coordinate.lng.toFixed(4)))]), _c('i', {
    staticClass: "ml-2 fa fa-angle-up"
  })]), _c('transition', {
    attrs: {
      "name": "el-zoom-in-bottom"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expanded),
      expression: "expanded"
    }],
    attrs: {
      "id": "container"
    }
  }, [_c('form', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Coordenadas geográficas")]), _c('div', {
    staticClass: "m-3 body"
  }, [_c('select', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "disabled": true
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    }
  }, [_vm._v("Sirgas 2000 geográfico")])]), _c('div', {
    staticClass: "form-row mt-2"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v("Latitude")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.latitude),
      expression: "latitude"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('latitude|max_value:85|min_value:-85'),
      expression: "'latitude|max_value:85|min_value:-85'"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "placeholder": "± 13.2827",
      "name": "latitude"
    },
    domProps: {
      "value": (_vm.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.latitude = $event.target.value
      }
    }
  }), _c('input-errors', {
    attrs: {
      "name": "latitude"
    }
  })], 1), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v("Longitude")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.longitude),
      expression: "longitude"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('longitude'),
      expression: "'longitude'"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "placeholder": "± 26.2589",
      "name": "longitude"
    },
    domProps: {
      "value": (_vm.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.longitude = $event.target.value
      }
    }
  }), _c('input-errors', {
    attrs: {
      "name": "longitude"
    }
  })], 1)])]), _c('div', {
    staticClass: "footer py-2"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-secondary float-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-close"
  }), _vm._v(" Cancelar")]), _c('button', {
    staticClass: "btn btn-sm btn-primary float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showCoordinates()
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-check"
  }), _vm._v(" Aplicar")])])])])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ef7e7028","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Coordinates.vue
// module id = 491
// module chunks = 1